import React, { Component, Fragment } from 'react';

import { DocumentFieldText } from 'components/cards/document/preview/DocumentFieldText';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import FieldsGroup from 'components/cards/document/fields/FieldsGroup';
import { strToDate } from 'mappers/commonMapper';
import { getValue, xmlArrayToObj, checkGroup } from 'helpers/documentsHelpers';
import { cardEdited } from '../fields/CardEdited';

export default class InterviewLineManager extends Component {
    header = checkGroup(({ interviewDate, candidateName, customerName, position }) => (
        <FieldsGroup translate="interview">
            <DefinitionField translate="xml.PplZakInterv.INTDATE" show={!!interviewDate}>
                <DocumentFieldText
                    name="xml.PplZakInterv.INTDATE"
                    value={interviewDate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplZakInterv.CANDNAME" show={!!candidateName}>
                <DocumentFieldText
                    name="xml.PplZakInterv.CANDNAME"
                    value={candidateName}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplZakInterv.ZAKNAME" show={!!customerName}>
                <DocumentFieldText
                    name="xml.PplZakInterv.ZAKNAME"
                    value={customerName}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplZakInterv.POSNAME" show={!!position}>
                <DocumentFieldText
                    name="xml.PplZakInterv.POSNAME"
                    value={position}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    informationFromManager = checkGroup(({ managerInfo }) => (
        <FieldsGroup translate="managerInfo">
            <DocumentFieldText
                name="xml.PplZakInterv.ZAKINFO"
                value={managerInfo}
            />
        </FieldsGroup>
    ))

    informationFromCandidate = checkGroup(({ managerInfo }) => (
        <FieldsGroup translate="candidateInfo">
            <DocumentFieldText
                name="xml.PplZakInterv.CANDINFO"
                value={managerInfo}
            />
        </FieldsGroup>
    ))

    render() {
        const { xml } = this.props;
        const xmlObject = xmlArrayToObj(xml);

        return (
            <Fragment>
                {this.header({
                    interviewDate: getValue(xmlObject.INTDATE),
                    candidateName: getValue(xmlObject.CANDNAME),
                    customerName: getValue(xmlObject.ZAKNAME),
                    position: getValue(xmlObject.POSNAME)
                })}
                {this.informationFromManager({
                    managerInfo: getValue(xmlObject.ZAKINFO)
                })}
                {this.informationFromCandidate({
                    managerInfo: getValue(xmlObject.CANDINFO)
                })}
                {cardEdited({
                    documentUpdateDate: strToDate(getValue(xmlObject.whenchange)),
                    documentUpdatePerson: getValue(xmlObject.whochange),
                    documentLettersUpdate: getValue(xmlObject.howmanylettersadded)
                })}
            </Fragment>
        );
    }
}
